import { initializeScenario } from '../actions/internalActions';
import { initializeAgenda } from '../actions/publicActions';
import { getUpNextCalendarEventId } from '../selectors/upNextEventCalendarCacheSelectors';
import { getTodoCache } from '../store/todoCache';
import { tryFetchAgendaViewMeetingInsights } from '../utils/tryFetchAgendaViewMeetingInsights';
import { logUsage } from 'owa-analytics';
import { initializeCalendarEventsLoader } from 'owa-calendar-events-loader';
import { lazyInitializeEventRelatedContent } from 'owa-calendar-related-content-initialization';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isInsightsEnabledForUser } from 'owa-meeting-insights-types-and-flights';
import { TodoDescriptorType } from 'owa-todo-cache';
import { initializeUpNextEventLoader } from 'owa-upnext-event-loader';
import { orchestrator } from 'satcheljs';
import {
    getScenarioListCacheId,
    getScenarioUpNextCacheId,
    getInitialDateRange,
} from '../selectors/agendaStoreSelectors';

export const initializeAgendaOrchestrator = orchestrator(initializeAgenda, actionMessage => {
    const {
        date,
        scenarioId,
        calendarIds,
        todoActionSource,
        shouldShowTasks,
        shouldShowDeclinedEvents,
        viewConfig,
        entrySource,
        currentFilters,
        perfDatapoint,
    } = actionMessage;
    initializeScenario(
        date,
        scenarioId,
        shouldShowTasks,
        todoActionSource,
        shouldShowDeclinedEvents,
        viewConfig,
        entrySource,
        currentFilters
    );
    const initialDateRange = getInitialDateRange(scenarioId, date);
    initializeCalendarEventsLoader(
        getScenarioListCacheId(scenarioId),
        calendarIds,
        initialDateRange
    ).then(() => {
        if (!perfDatapoint?.current?.hasEnded) {
            perfDatapoint?.current?.end();
        }
    });
    if (shouldShowTasks) {
        getTodoCache(scenarioId)
            .fetchTasks({
                type: TodoDescriptorType.DueDate,
                startDate: initialDateRange.start,
                endDate: initialDateRange.end,
            })
            .then(todos => {
                if (todos?.length > 0) {
                    logUsage('TodosViewedInAgenda', undefined, {
                        isCore: true,
                    });
                }
            });
        getTodoCache(scenarioId).subscribeNotifications();
    }
    if (isInsightsEnabledForUser()) {
        lazyInitializeEventRelatedContent.importAndExecute();
    }
    initializeUpNextEventLoader(calendarIds, getScenarioUpNextCacheId(scenarioId));
    if (isFeatureEnabled('cal-meeting-insights-noCache')) {
        tryFetchAgendaViewMeetingInsights(getUpNextCalendarEventId(scenarioId));
    }
});
